import { useEffect, useState } from "react";
import AddUserForm from "../form/addUser/AddUserForm";
import useGetData from "../../../CustomHooks/useAxios/useGetData";
import DialogBox from "../../../components/UI/DialogBox";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import spin from "../../../assets/icons/spin.png";
import { ADD_USER, USER_SETUP } from "../apiEndpoints";
import usePostData from "../../../CustomHooks/useAxios/usePostData";
import MainPageLayout from "../../../layout/MainPageLayout";
import { prepareAddUserFormData } from "../../../functions/prepareAddUserFormData";

const AddUserPage = () => {
  const [files, setFiles] = useState({});
  const { data, isLoaded, error, getData } = useGetData();
  const { executePost, loading, formError, successResponse, setFormError } =
    usePostData();

  useEffect(() => {
    getData(USER_SETUP);
  }, []);

  // execute post api
  const sendData = async (formValues, reset) => {
    // send data into form data
    const formData = prepareAddUserFormData(formValues);
    // API calling
    executePost(formData, ADD_USER, reset);
  };
  return (
    <MainPageLayout headerConfig={{ title: "Add User" }}>
      {isLoaded && !error ? (
        <AddUserForm
          userSetup={data}
          files={files}
          setFiles={setFiles}
          sendData={sendData}
          loading={loading}
          successResponse={successResponse}
        />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
      {formError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(formError)}
          closeAction={() => setFormError("")}
        />
      )}
    </MainPageLayout>
  );
};
export default AddUserPage;
